import { Box, Text } from "@chakra-ui/react";
import { asHTML } from "@prismicio/client";
import CalloutBox from "./CalloutBox";
import { checklistSx, richTextSx } from "./richTextStyles";

// Colors match the website's Bodycontent slice (antaia-website src/slices/Bodycontent)
const GREEN = "#5A8A1A";
const HEADING_INK = "#0E3137";

// Larger body copy than the shared richTextSx default (body.m/16px) — this slice is
// a page's main reading content (e.g. "At a glance"), not a compact card/list
// description like the other slices sharing richTextSx, so it reads better bigger.
// Lists use the shared green-checkmark treatment (checklistSx) instead of plain
// browser bullets, matching DualColumnContentSlice.jsx.
const MAIN_CONTENT_SX = {
  ...richTextSx,
  p: { ...richTextSx.p, fontSize: "body.l" },
  ...checklistSx,
  li: { ...checklistSx.li, fontSize: "body.l" },
};

export default function BodycontentSlice({ slice }) {
  const { heading, sub_heading, main_content, call_out } = slice.primary;

  return (
    <Box>
      {heading && (
        <Text fontSize="24px" fontWeight="700" color={HEADING_INK} mb={sub_heading?.length > 0 ? 1 : 4}>
          {heading}
        </Text>
      )}
      {sub_heading?.length > 0 && (
        <Box sx={{ p: { fontSize: "body.l", color: GREEN, fontWeight: "600", mb: 4 } }} dangerouslySetInnerHTML={{ __html: asHTML(sub_heading) }} />
      )}
      {main_content?.length > 0 && (
        <Box sx={MAIN_CONTENT_SX} dangerouslySetInnerHTML={{ __html: asHTML(main_content) }} />
      )}
      <CalloutBox callOut={call_out?.[0]} />
    </Box>
  );
}
